<div class="product-information-container" fxLayout="column" fxLayoutAlign="space-around stretch" fxLayoutGap="30px">
    <p><strong>{{'pcTitle' | translate}}</strong></p>
    <mat-card class="product-overview-card">
        <div *ngIf="request.requestType != 'Inquiry request'">
            <p><strong>{{'brand' | translate}}: </strong> {{request.asset.brand}}</p>
            <p><strong>{{'model' | translate}}: </strong> {{request.asset.model}}</p>
            <p><strong>{{'serialNumber' | translate}}/{{'imeiNumber' | translate}}:</strong> {{request.assetNumber}}</p>
            
            <p><strong>{{request.requestType}}</strong></p>
            <p *ngIf="request.requestType == 'Broken request'"><strong *ngIf="request.requestType == 'Broken request'">{{'problem' | translate}}:</strong>  {{request.qualification}}</p>
            <p>{{request.description}}</p>
            
            <div *ngIf="request.attachments.length >= 1">    
                <p *ngFor="let attachment of request.attachments; let i = index"><strong>File:</strong> {{attachment.path}}</p>
            </div>
        </div>

        <div *ngIf="request.requestType == 'Inquiry request'">
            <h3>{{'pcInquiryTitl' | translate}}</h3>
            <p>{{'pcInquiryText' | translate}}</p>
        </div>
        
    </mat-card>

    <div class="warranty-information" class="product-information-container" fxLayout="column" fxLayoutAlign="space-around stretch" fxLayoutGap="30px">
        <mat-card class="product-overview-card">
            <p><strong>{{'warrantyInfo p1' | translate}}</strong></p>
            <p>{{'warrantyInfo p2' | translate}}</p>
            <p>{{'warrantyInfo p3' | translate}}</p>
            <p>{{'warrantyInfo p4' | translate}}</p>

            

            <mat-checkbox [(ngModel)]="isTermsAgreed" name="terms">{{'pcT&T' | translate}} <a class="link" href="https://www.econocom.be/fr/GTC-BE-2021" target="_blank">{{'terms&conditions' | translate}}</a></mat-checkbox>
        </mat-card>
    </div>


    <div fxLayoutAlign="center center">
        <button mat-raised-button [disabled]="!isTermsAgreed" color="primary" (click)="onSubmit()">{{'pcButton' | translate}}</button>
    </div>

</div>

